import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';


function DotCircleIcon(props: SvgIconProps) {
    return (
      <SvgIcon {...props}>
        <path d="M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Zm0,26A12,12,0,1,1,28,16,12,12,0,0,1,16,28Z"/><path d="M16,10a6,6,0,1,0,6,6A6,6,0,0,0,16,10Z"/><rect id="_Transparent_Rectangle_"  />
    </SvgIcon>
    );
  }


export default DotCircleIcon;